module.exports = __webpack_public_path__ + "templates/confirmed.html";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=templates/[name].[ext]!./src/app/auth/components/confirmed/confirmed.html
// module id = 309
// module chunks = 15